import { lazy } from 'react'
import RequireAuthentication from '@/router/guards/RequireAuthentication'
import ScreeningConfirmContact from '../ConfirmContact/pages/SkipScreeningConfirmContact'

const WaitingRoom = lazy(
  () => import('@/modules/Attendance/submodules/Immediate/pages/WaitingRoom'),
)
const SpecialitiesSearch = lazy(
  () =>
    import(
      '@/modules/Attendance/submodules/Immediate/pages/SpecialitiesSearchImmediate'
    ),
)

const routes = [
  <RequireAuthentication
    path="/atendimento-imediato/especialidades"
    key="/atendimento-imediato/especialidades"
    exact
    component={SpecialitiesSearch}
  />,
  <RequireAuthentication
    path="/atendimento-imediato/waiting"
    key="/atendimento-imediato/waiting"
    exact
    component={WaitingRoom}
  />,
  <RequireAuthentication
    path="/atendimento-imediato/atualizar-dados"
    key="/atendimento-imediato/atualizar-dados"
    exact
    component={ScreeningConfirmContact}
  />,
]

export default routes
